'use strict';

angular.module('imagetrend.components')
    .directive('hlpQuery', ['Queries', '$state', 'Cache', function (Queries, $state, Cache) {
        return {
            restrict: 'EA',
            transclude: true,
            replace: true,
            scope: {
                // scope
                records: '=?',
                cacheRecords: '=?',
                recordsLoading: '=?',
                bulkActions: '=?',
                bulkActionItems: '=?',
                state: '@?',
                previewId: '=?',
                service: '@?',
                bulkActionRunning: '=?'
            },
            controller: ['$scope', 'Format', function ($scope, Format) {
                $scope.queryChanged = function (query) {
                    $scope.query = query;
                    var link = null;
                    var columns = [];
                    var filters = [];
                    var advancedFilters = [];
                    
                    if (query != null) {
                        if ($scope.previewId == null) {
                            Cache.setState('query', query);
                        }

                        if (query.display_bulk_actions) {
                            $scope.vm.bulkActions = angular.copy($scope.bulkActions);
                        }
                        
                        if (query.query_page != null && query.query_page.link_state != null && query.query_page.query_page_parameters.length > 0) {
                            if ($scope.previewId == null) {
                                link = {};
                                link.state = query.query_page.link_state;
                                link.params = [];
                            }
                            query.query_page.query_page_parameters.forEach(function (queryPageParameter) {
                                var param = {};
                                param.name = queryPageParameter.name;
                                param.field = queryPageParameter.json;
                                if ($scope.previewId == null) {
                                    link.params.push(param);
                                }
                            })
                        }

                        query.query_column_values.sort(sortObjectArray('sort_order')).forEach(function (queryColumnValue) {
                            var column = {};
                            column.label = queryColumnValue.header;
                            column.field = queryColumnValue.query_column.json;
                            column.type = queryColumnValue.query_column.type;

                            if (column.type == 'date')
                                column.revertTimeZone = true;

                            if (queryColumnValue.query_column.state != null) {
                                if ($scope.previewId == null) {
                                    column.link = {};
                                    column.link.state = queryColumnValue.query_column.state;
                                    column.link.params = [];
                                }
                                queryColumnValue.query_column.query_column_parameters.forEach(function (queryColumnParameter) {
                                    var param = {};
                                    param.name = queryColumnParameter.name;
                                    param.field = queryColumnParameter.json;                                    
                                    if ($scope.previewId == null) {
                                        column.link.params.push(param);
                                    }
                                })
                            }
                            columns.push(column);
                        })

                        query.query_filter_values.sort(sortObjectArray('sort_order')).forEach(function (queryFilterValue) {
                            var filter = {};
                            filter.id = queryFilterValue.id;
                            filter.name = queryFilterValue.display_label;
                            if (queryFilterValue.query_filter) {
                                filter.field = queryFilterValue.query_filter.json;
                                filter.service = queryFilterValue.query_filter.service;
                                filter.method = queryFilterValue.query_filter.method;
                                filter.type = queryFilterValue.query_filter.type;
                            }
                            filters.push(filter);
                        })

                        query.query_advanced_filter_values.sort(sortObjectArray('sort_order')).forEach(function (queryAdvancedFilterValue) {
                            var advancedFilter = {};
                            advancedFilter.id = queryAdvancedFilterValue.id;
                            advancedFilter.name = queryAdvancedFilterValue.label;
                            advancedFilter.field = queryAdvancedFilterValue.query_advanced_filter.json;
                            advancedFilter.type = queryAdvancedFilterValue.query_advanced_filter.type;
                            advancedFilter.exactMatch = queryAdvancedFilterValue.query_advanced_filter.exact_match;
                            advancedFilters.push(advancedFilter);
                        })
                        if (query.default_sort != null) {
                            $scope.defaultSort = query.default_sort;
                        } else {
                            $scope.defaultSort = "modified_on"; // OK if that field does not exist
                        }
                        if (query.default_order != null) {
                            $scope.defaultOrder = query.default_order;
                        }
                        if ($scope.records != null) {
                            var ifStatement = '';

                            query.query_criteria.sort(sortObjectArray('sort_order')).forEach(function (queryCriteria, index) {
                                if (index > 0) {
                                    if (queryCriteria.and_flag) {
                                        ifStatement += ' && ';
                                    }
                                    else {
                                        ifStatement += ' || ';
                                    }
                                }

                                for (var i = 0; i < queryCriteria.left_parenthesis; i++) {
                                    ifStatement += '(';
                                }

                                var criteriaValue = queryCriteria.value;
                                var skipit = false;
                                var doquotes = true;

                                if (queryCriteria.query_calculated_value != null) {
                                    if (queryCriteria.query_field != null && queryCriteria.query_field.type == 'days') {
                                        skipit = true;
                                        var daysVal = Number(queryCriteria.query_calculated_value.value);
                                        if (!isNaN(daysVal)) {
                                            var now = new Date();
                                            now.setHours(0, 0, 0, 0);

                                            var compareDate = new Date();
                                            compareDate.setDate(compareDate.getDate() - daysVal);
                                            compareDate.setHours(0, 0, 0, 0);
                                            if (daysVal < 0) {
                                                //Options in the future (i.e. next 90 days)
                                                ifStatement += "(record['" + queryCriteria.query_field.json + "'] != null && isValidDate(record['" + queryCriteria.query_field.json + "']) && " +
                                                    (queryCriteria.query_operator.name == '<>' ? "!" : "") +
                                                    "(" + now.getTime() + " <= record['" + queryCriteria.query_field.json + "'].revertTimeZone().setHours(0, 0, 0, 0) && " + compareDate.getTime() + " >= record['" + queryCriteria.query_field.json + "'].revertTimeZone().setHours(0, 0, 0, 0)))";
                                            }
                                            else if (daysVal == 1) {
                                                //"Yesterday" option - excludes todays date
                                                ifStatement += "(record['" + queryCriteria.query_field.json + "'] != null && isValidDate(record['" + queryCriteria.query_field.json + "']) && " +
                                                    (queryCriteria.query_operator.name == '<>' ? "!" : "") +
                                                    "(" + now.getTime() + " > record['" + queryCriteria.query_field.json + "'].revertTimeZone().setHours(0, 0, 0, 0) && " + compareDate.getTime() + " <= record['" + queryCriteria.query_field.json + "'].revertTimeZone().setHours(0, 0, 0, 0)))";
                                            }
                                            else {
                                                //Options in the past (i.e. last 90 days)
                                                ifStatement += "(record['" + queryCriteria.query_field.json + "'] != null && isValidDate(record['" + queryCriteria.query_field.json + "']) && " +
                                                    (queryCriteria.query_operator.name == '<>' ? "!" : "") +
                                                    "(" + now.getTime() + " >= record['" + queryCriteria.query_field.json + "'].revertTimeZone().setHours(0, 0, 0, 0) && " + compareDate.getTime() + " <= record['" + queryCriteria.query_field.json + "'].revertTimeZone().setHours(0, 0, 0, 0)))";
                                            }
                                        }
                                    }
                                    else {
                                        if (queryCriteria.query_field != null && queryCriteria.query_field.type == 'boolean') {
                                            doquotes = false;
                                        }
                                        criteriaValue = queryCriteria.query_calculated_value.value;
                                    }
                                }

                                if (!skipit) {
                                    if (doquotes) {
                                        ifStatement += "'" + criteriaValue + "'";
                                    }
                                    else {
                                        ifStatement += criteriaValue;
                                    }
                                    if (queryCriteria.query_operator.name == '=') {
                                        ifStatement += '==';
                                    }
                                    else if (queryCriteria.query_operator.name == '<>') {
                                        ifStatement += '!=';
                                    }
                                    ifStatement += "Format.evaluateJSON(record,'" + queryCriteria.query_field.json + "')";
                                }

                                for (var i = 0; i < queryCriteria.right_parenthesis; i++) {
                                    ifStatement += ')';
                                }
                            })
                            if (ifStatement != '' && $scope.records != null) {
                                var filtered = [];
                                $scope.records.forEach(function (record) {
                                    if (eval(ifStatement)) {
                                        filtered.push(record);
                                    }
                                })
                                $scope.filteredRecords = filtered;
                            }
                            else {
                                $scope.filteredRecords = $scope.records;
                            }
                        }
                    }

                    $scope.link = link;
                    $scope.columns = columns;
                    $scope.filters = filters;
                    $scope.advancedFilters = advancedFilters;

                }                
            }],
            templateUrl: 'templates/query/query.html',
            link: function (scope, elem, attrs, ctrl) {
                scope.link = null;
                scope.columns = null;
                scope.filters = null;
                scope.advancedFilters = null;
                scope.loading = true;
                scope.vm = {
                    bulkActions: []
                }
                scope.recordsWatchInit = false;

                scope.$watch('query', function (query) {
                    scope.query = query;
                }, true);

                scope.$watch('records', function (records) {
                    if (scope.query != null && records != null && !scope.recordsWatchInit) {
                        scope.queryChanged(scope.query);
                        scope.recordsWatchInit = true;
                    }
                }, true);

                if (typeof scope.previewId == 'undefined' || scope.previewId == null) {
                    Cache.getState('query').then(function (query) {
                        if (scope.loading) {
                            scope.query = query;
                            scope.queryChanged(scope.query);
                        }
                    }).catch(function (response) {
                        return $q.reject(response.data);
                    });
                }

                var queryState = $state.current.name;
                if (attrs.state != null) {
                    queryState = attrs.state;
                }

                Queries.get(queryState, true).then(function (queries) {
                    scope.queries = queries;
                    if (scope.queries.length > 0) {
                        if (typeof scope.previewId == 'undefined' || scope.previewId == null) {
                            Cache.getState('query').then(function (cachedQuery) {
                                if (cachedQuery != null) {
                                    var found = false;
                                    scope.queries.forEach(function (query) {
                                        if (query.id == cachedQuery.id && !found) {
                                            scope.query = query;
                                            found = true;
                                        }
                                    })
                                    if (scope.query == null || !found) {
                                        scope.query = scope.queries[0];
                                    }
                                }
                                else {
                                    // if no query is cached, use the user's default view if it exists
                                    var found = false;
                                    scope.queries.forEach(function (query) {
                                        if (query.default_view == true) {
                                            scope.query = query;
                                            found = true;
                                        }
                                        if (scope.query == null || !found) {
                                            scope.query = scope.queries[0];
                                        }
                                    })
                                }
                                scope.queryChanged(scope.query);
                                scope.loading = false;
                            }).catch(function () {
                                //if we get into the error catch then load default view
                                var found = false;
                                scope.queries.forEach(function (query) {
                                    if (query.default_view == true) {
                                        scope.query = query;
                                        found = true;
                                    }
                                    if (scope.query == null || !found) {
                                        scope.query = scope.queries[0];
                                    }
                                })
                                scope.queryChanged(scope.query);
                                scope.loading = false;
                            });      
                        }
                        else {
                            var found = false;
                            scope.queries.forEach(function (query) {
                                if (((scope.query != null && query.id == scope.query.id) || (scope.previewId != null && query.id == scope.previewId.toLowerCase())) && !found) {
                                    found = true;
                                    scope.query = query;
                                }
                            })
                            if (!found) {
                                scope.query = scope.queries[0];
                            }
                            scope.queryChanged(scope.query);
                            scope.loading = false;
                        }
                    }
                    else {
                        scope.query = null;
                        scope.queryChanged(scope.query);
                        scope.loading = false;
                    }
                })
            }
        };
    }])
    ;